export default __webpack_public_path__ + "static/figma-aa02299efaad6471581b63820e8a5809.jpg";